var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.117 0.798916C11.3893 0.797272 11.6511 0.903725 11.845 1.09491L28.873 17.5149C29.2072 17.8366 29.473 18.2224 29.6545 18.6492C29.8361 19.076 29.9297 19.5351 29.9297 19.9989C29.9297 20.4627 29.8361 20.9218 29.6545 21.3486C29.473 21.7754 29.2072 22.1612 28.873 22.4829L11.845 38.8829C11.7522 38.9993 11.6357 39.0945 11.5032 39.1623C11.3707 39.2301 11.2253 39.2689 11.0766 39.2761C10.928 39.2833 10.7795 39.2588 10.641 39.2042C10.5026 39.1495 10.3774 39.066 10.2737 38.9592C10.1701 38.8524 10.0904 38.7248 10.0399 38.5848C9.98941 38.4447 9.96934 38.2956 9.98101 38.1472C9.99267 37.9988 10.0358 37.8547 10.1075 37.7242C10.1793 37.5938 10.2779 37.4802 10.397 37.3909L27.413 20.9709C27.5434 20.8448 27.6471 20.6938 27.7179 20.5268C27.7888 20.3598 27.8253 20.1803 27.8253 19.9989C27.8253 19.8175 27.7888 19.638 27.7179 19.471C27.6471 19.304 27.5434 19.153 27.413 19.0269L10.397 2.60691C10.2471 2.46189 10.1437 2.27559 10.0999 2.07166C10.0562 1.86774 10.074 1.65541 10.1512 1.46164C10.2283 1.26787 10.3613 1.10141 10.5333 0.983414C10.7053 0.86541 10.9085 0.801193 11.117 0.798916Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.c85742157b4eb84991f2f764125916ab.svg";
export { ForwardRef as ReactComponent };